import { app } from '../../../app';

app.component('requestCenterUser', {
    bindings: {
        companyId: '<',
    },
    templateUrl: require('./request-center-user.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/user/request-center/request-center-user.component.js